const NewFeatureNotification = () => {
    return (
        <div className="vh-100 d-flex flex-column">
            <div className="flex-grow-1 footer p-6 text-center pt-15 text-dark fs-1 position-sticky sticky-top bg-lightPrimary">
                <div className='big-font mt-15 fw-bold text-primary'>
                    This Feature is coming soon.
                </div>
            </div>
        </div>

    );
}

export default NewFeatureNotification;